import React, { forwardRef, useId } from 'react';
import './RedButton.css';

/*
    Pulsante rosso della modalità pulsante, tutto in SVG e CSS: nessuna immagine da scaricare.
    lit = acceso (il tempo scorre): il disco più chiaro sfuma sopra quello da fermo.
    Il ref punta al <button>, a cui Game_button collega i listener di click e touch.
*/

//bordo del disco: stop (posizione sul raggio, rosso) misurati sulle PNG originali
const IDLE_RIM = [[0, 189], [0.874, 189], [0.919, 184], [0.941, 179], [0.978, 169], [1, 160]];
const LIT_RIM = [[0, 245], [0.859, 245], [0.889, 243], [0.919, 238], [0.948, 230], [1, 208]];

const rim = (id, stops) => (
    <radialGradient id={id} cx="50%" cy="50%" r="50%">
        {stops.map(([offset, red]) => <stop key={offset} offset={offset} stopColor={`rgb(${red},0,0)`} />)}
    </radialGradient>
);

const RedButton = forwardRef(({ lit = false, label }, ref) => {
    const u = useId();

    return (
        <div className="red-btn-wrap">
            <button type="button" ref={ref} className={"red-btn " + (lit ? "red-btn-lit" : "red-btn-idle")} aria-label={label}>
                <span className="red-btn-halo" aria-hidden="true"></span>
                <span className="red-btn-ring" aria-hidden="true"></span>
                <span className="red-btn-ring red-btn-ring-2" aria-hidden="true"></span>
                <svg className="red-btn-svg" viewBox="0 0 270 270" aria-hidden="true">
                    <defs>
                        {rim(u + "i", IDLE_RIM)}
                        {rim(u + "l", LIT_RIM)}
                        {/* ombra interna, più scura in alto: si vede solo mentre il pulsante è premuto */}
                        <radialGradient id={u + "s"} cx="50%" cy="66%" r="62%">
                            <stop offset=".5" stopColor="#3a0000" stopOpacity="0" />
                            <stop offset="1" stopColor="#3a0000" stopOpacity=".5" />
                        </radialGradient>
                    </defs>
                    <circle cx="135" cy="135" r="135" fill={`url(#${u}i)`} />
                    <circle className="red-btn-lit-disc" cx="135" cy="135" r="135" fill={`url(#${u}l)`} />
                    <circle className="red-btn-shade" cx="135" cy="135" r="135" fill={`url(#${u}s)`} />
                    <g className="red-btn-hl">
                        <ellipse cx="75" cy="45" rx="40.2" ry="18.9" transform="rotate(-30.1 75 45)" fill="#fff" fillOpacity=".5" />
                        <ellipse cx="186.5" cy="234.1" rx="24.4" ry="14.1" transform="rotate(-28.2 186.5 234.1)" fill="#fff" fillOpacity=".25" />
                    </g>
                </svg>
            </button>
        </div>
    );
});

export default RedButton;
